export default "__VITE_ASSET__BlXsZVSK__"